import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Table, Input, DatePicker } from 'antd';
import moment from 'moment';
// import UilEdit from '@iconscout/react-unicons/icons/uil-edit';
// import { Link } from 'react-router-dom';
import { UilSearch, UilLocationPoint } from '@iconscout/react-unicons';

import { tableColumns } from './tableColumns';

import { PageHeader } from '../../components/page-headers/page-headers';
// import { AutoComplete } from '../../components/autoComplete/autoComplete';
import { Button } from '../../components/buttons/buttons';
import { Cards } from '../../components/cards/frame/cards-frame';

import { Main, CardToolbox, TableWrapper } from '../styled';
import { UserTableStyleWrapper } from '../pages/style';
import { getMachineData, exportToExcelData } from '../../redux/machines/actionCreator';

function MachineRawData() {
  const dispatch = useDispatch();

  const { searchData, machines, loading } = useSelector((state) => {
    return {
      searchData: state.headerSearchData,
      machines: state.machines.ams,
      loading: state.machines.loading,
    };
  });

  const [hasFetched, setHasFetched] = useState(false);
  const [state, setState] = useState({
    notData: searchData,
    selectedRowKeys: 0,
    selectedRows: 0,
    machineId: '',
    selectedDate: '',
    isSearch: false,
  });

  // const { notData } = state;

  useEffect(() => {
    if (!hasFetched) {
      dispatch(getMachineData(''));
      setHasFetched(true);
    }

    return () => {
      // Any cleanup code you want to execute when the component unmounts or the effect changes
    };
  }, [hasFetched, dispatch, !state.isSearch]);

  const tableData = [];

  if (!loading) {
    if (machines?.length !== 0) {
      machines.map((machine, i) => {
        const { machineid, starttime, endtime, duration, pdcount, encodercount } = machine;

        return tableData.push({
          key: i,
          machineid,
          starttime: moment(starttime).format('DD-MM-YYYY hh:mm:ss A'),
          endtime: moment(endtime).format('DD-MM-YYYY hh:mm:ss A'),
          pdcount,
          duration,
          encodercount,
          // action: (
          //   <div className="table-actions">
          //     <Button className="btn-icon" type="info" to="#" shape="circle">
          //       <UilEdit />
          //     </Button>
          //   </div>
          // ),
        });
      });
    }
  }

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
      isSearch: false,
    });
  };

  const handleDateChange = (date, dateString) => {
    // const isCheck = state.machineId !== '' ? true : false;
    setState({
      ...state,
      selectedDate: dateString,
      isSearch: false,
    });
  };

  const searchHandler = useCallback(() => {
    // if the search element is empty machine id and selected date return false
    if (state.machineId === '' && state.selectedDate === '') return;

    // Create a URLSearchParams object
    const urlParams = new URLSearchParams();
    // Add parameters to the URLSearchParams object
    if (state.machineId !== '') urlParams.append('machineId', state.machineId);
    if (state.selectedDate !== '') urlParams.append('date', state.selectedDate);

    // Combine the URL with the query parameters
    const query = `?${urlParams.toString()}`;

    setState({ ...state, isSearch: true });
    dispatch(getMachineData(query));
  }, [state]);

  const clearSearchHandler = () => {
    setState({ ...state, isSearch: false, machineId: '', selectedDate: '' });
    dispatch(getMachineData(''));
  };

  const exportToExcelHandler = useCallback(() => {
    // Create a URLSearchParams object
    const urlParams = new URLSearchParams();
    // Add parameters to the URLSearchParams object
    if (state.machineId !== '') urlParams.append('machineId', state.machineId);
    if (state.selectedDate !== '') urlParams.append('date', state.selectedDate);
    urlParams.append('all', state.checked ? 'true' : 'false');

    // Combine the URL with the query parameters
    const query = `?${urlParams.toString()}`;

    setState({ ...state });
    dispatch(exportToExcelData(query));
  }, [state]);

  return (
    <>
      <CardToolbox>
        <PageHeader
          className="ninjadash-page-header-main"
          ghost
          title="Raw Data"
          subTitle={
            <>
              <span className="title-counter">{machines?.length} Data</span>
              {/* <AutoComplete
                onSearch={handleSearch}
                dataSource={notData}
                placeholder="Search by Name"
                width="100%"
                patterns
              /> */}
            </>
          }
          buttons={[
            <div className="input-search-container align-center-v">
              <Input
                size="medium"
                prefix={<UilSearch />}
                className="search-input"
                id="title"
                placeholder="Machine Id"
                name="machineId"
                onChange={handleChange}
                value={state.machineId}
              />
              <DatePicker
                id="location"
                size="madium"
                className="search-datepicker"
                prefix={<UilLocationPoint />}
                placeholder="Date "
                onChange={handleDateChange}
                value={state.selectedDate !== '' ? moment(state.selectedDate) : ''}
              />
            </div>,
            !state.isSearch ? (
              <Button onClick={searchHandler} size="madium" type="primary">
                <UilSearch /> Search
              </Button>
            ) : (
              <Button onClick={clearSearchHandler} size="madium" type="default">
                <UilSearch /> Clear
              </Button>
            ),
            <Button onClick={exportToExcelHandler} size="medium" type="default">
              Export
            </Button>,
          ]}
        />
      </CardToolbox>

      <Main>
        <Row gutter={15}>
          <Col md={24}>
            <Cards headless>
              <UserTableStyleWrapper>
                <TableWrapper className="table-responsive">
                  <Table
                    dataSource={tableData}
                    columns={tableColumns}
                    size="small"
                    loading={loading}
                    pagination={{
                      defaultPageSize: 100,
                      total: machines?.length,
                      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    }}
                  />
                </TableWrapper>
              </UserTableStyleWrapper>
            </Cards>
          </Col>
        </Row>
      </Main>
    </>
  );
}

export default MachineRawData;
